import React from 'react';
import PropTypes from 'prop-types';
import './TagBadge.css';

// Função para calcular cor de contraste
const getContrastColor = (hexColor) => {
  // Remove o # se presente
  const hex = hexColor.replace('#', '');

  // Converte para RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calcula a luminância
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Retorna branco para cores escuras e preto para cores claras
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};

function TagBadge({ tag, size, showRemove, onRemove }) {
  if (!tag) return null;

  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove(tag);
    }
  };

  return (
    <span
      className={`tag-badge tag-badge--${size}`}
      style={{
        backgroundColor: tag.color || '#6C757D',
        color: getContrastColor(tag.color || '#6C757D'),
      }}
      title={tag.description || tag.name}
    >
      <span className="tag-badge__text">{tag.name}</span>
      {showRemove && (
        <button
          type="button"
          className="tag-badge__remove"
          onClick={handleRemove}
          aria-label={`Remover etiqueta ${tag.name}`}
        >
          ×
        </button>
      )}
    </span>
  );
}

TagBadge.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  showRemove: PropTypes.bool,
  onRemove: PropTypes.func,
};

TagBadge.defaultProps = {
  size: 'medium',
  showRemove: false,
  onRemove: null,
};

export default TagBadge;
